"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgLightning02 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M8.494 1H8.46a1.92 1.92 0 0 0-.64.082 1.5 1.5 0 0 0-.56.346 1.92 1.92 0 0 0-.36.536l-.015.031-4.214 8.428a6.461 6.461 0 0 0-.235.506c-.065.167-.16.452-.11.79a1.5 1.5 0 0 0 .624 1.01c.28.196.578.24.756.256.17.015.372.015.558.015h4.893l-2.614 8.713a1 1 0 0 0 1.678.981l12.219-12.671c.183-.19.364-.378.497-.543.12-.149.356-.458.384-.881a1.5 1.5 0 0 0-.529-1.245c-.324-.274-.71-.318-.9-.335C19.678 7 19.417 7 19.153 7h-5.711l1.743-4.649a1 1 0 0 0-.936-1.35H8.494Z", fill: "currentColor" }) }))); };
exports.default = SvgLightning02;
